module.exports = __webpack_public_path__ + "static/media/cross.2f613d27.svg";